import { NgModule } from '@angular/core';
import { ConfirmDialogComponent } from './dialogs/confirm.dialog/confirm.dialog.component';
import { PrimeNgModule } from './modules/prime-ng.module';
import { CommonModule, DecimalPipe } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';
import { CurrencyFormatPipe } from './pipes/currency-format.pipe';

@NgModule({
  declarations: [ConfirmDialogComponent, CurrencyFormatPipe],
  imports: [CommonModule, PrimeNgModule, TranslocoModule],
  providers: [DecimalPipe],
  exports: [CurrencyFormatPipe],
})
export class SharedModule {}
